import React from "react";
import Cookies from "js-cookie";
// import { toast } from "react-toastify";
// import debounce from "lodash/debounce";
// import useCartListSparesMutation from "../../tanstack-query/cartList/useCartListSparesMutation";
// import useCartListDeleteItemMutation from "../../tanstack-query/cartList/useCartListDeleteItemMutation";
import { formatNumber } from "../../utils/formatNumber";
import dummyImage from "../../assets/dummyPreview.png";
import classes from "./spareItem.module.css";
import { Card } from "../card/Card";
// import { useQueryClient } from "@tanstack/react-query";

export const SpareItem = ({ item, onClick, onHotSellClick, isUpdating }) => {
  const authToken = Cookies.get("authToken");

  const handleHotSellButtonClick = (e) => {
    e.stopPropagation(); // Prevent card click
    e.preventDefault(); // Add this too
    onHotSellClick(item.id);
  };

  return (
    <Card className={classes.box} onClick={() => onClick(item.id)}>
      <div className={classes.box__img}>
        {item?.stock_status === "sold" && (
          <span className={classes.box__img__sold} />
        )}
        <img
          src={item.image}
          onError={(e) => (e.target.src = dummyImage)}
          alt={item.id}
          className={classes.box__image}
        />
      </div>

      <div className={classes.box__info}>
        <div className={classes.box__info__head}>
          <h1 className={classes.box__info__head__title}>{item.part_name}</h1>
          {authToken && (
            <span
              className={
                item.wishlist_status === 1
                  ? classes.box__info__fav__active
                  : classes.box__info__fav
              }
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
          )}
          <button
            type="button"
            className={
              item.is_hot_selling === 1
                ? classes.box__info_price__hotSellBtn__marked
                : classes.box__info_price__hotSellBtn__notMarked
            }
            onClick={handleHotSellButtonClick}
            disabled={isUpdating}
          >
            🔥 Hot Selling
          </button>
        </div>

        <h1 className={classes.box__info__head__title}>{`(${item.color})`}</h1>

        <div className={classes.box__info__price}>
          <div className={classes.box__discount}>
            <h3 className={classes.box__discount__container__discountedPrice}>
              Rs.{formatNumber(item.discounted_price)}
            </h3>

            {item.discount_percentage !== 0 && (
              <>
                <h3 className={classes.box__discount__container__price}>
                  Rs.{formatNumber(item.original_price)}
                </h3>
                <span className={classes.box__discount__img}>
                  {item.discount_percentage}% OFF
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};
